import DestinationPage from "@/components/DestinationPage";
const related = [
  { name: "Grecia", slug: "grecia", image: "https://images.unsplash.com/photo-1506242592132-b7476b527d50?w=600&q=80" },
  { name: "Spania", slug: "spania", image: "https://images.unsplash.com/photo-1758471206484-0eaa2568320c?w=600&q=80" },
  { name: "Turcia", slug: "turcia", image: "https://images.unsplash.com/photo-1774850691859-0e339f94bebb?w=600&q=80" },
];
export default function MuntenegruPage() {
  return (
    <DestinationPage
      name="Muntenegru" nameRo="Muntenegru" slug="muntenegru" flag="🇲🇪"
      heroImage="https://images.unsplash.com/photo-1689517686262-628708bbc5d7?w=1920&q=80"
      metaTitle="Vacanță în Muntenegru din Chișinău | Kotor, Budva, Bar – Premium Style Travel"
      metaDescription="Pachete turistice Muntenegru din Chișinău. Golful Kotor, Budva, Bar, Ulcinj. Marea Adriatică. Zbor + hotel. Sună +373 60609292 – Premium Style Travel."
      tagline="Golful Kotor, Marea Adriatică și munții impozanți — Muntenegru, bijuteria ascunsă a Balcanilor."
      description="Muntenegru este una dintre cele mai spectaculoase și accesibile destinații din Europa, situată pe malul Mării Adriatice. Golful Kotor, înscris în patrimoniul UNESCO, este considerat unul dintre cele mai frumoase fiorduri din lume. Budva este cel mai animat resort, cu plaje amenajate și viață de noapte vibrantă. Ulcinj, cu cea mai lungă plajă de nisip din Adriatică (13 km), este ideală pentru familii. Muntenegrul combină frumusețea naturală cu prețuri accesibile — o alternativă excelentă față de Grecia sau Croatia."
      highlights={[
        "Golful Kotor – fiord mediteranean UNESCO",
        "Budva – riviera montenegreană cu plaje superbe",
        "Cetatea Kotor – ziduri medievale și panorame spectaculare",
        "Sveti Stefan – insula-hotel iconic fotografiată din lume",
        "Muntele Lovćen – panorame de 360° asupra golfului",
        "Ulcinj – cea mai lungă plajă de nisip din Adriatică",
        "Perast – cel mai romantic orășel de pe coastă",
        "Parcul Național Durmitor – lacuri glaciare și canionul Tara",
      ]}
      included={[
        "✈️ Zbor dus-întors din Chișinău",
        "🏨 Cazare hotel / apartament 3★–5★",
        "🚌 Transfer aeroport – hotel – aeroport",
        "🛡️ Asigurare medicală de călătorie",
        "📋 Taxe incluse",
      ]}
      faqs={[
        { q: "Este nevoie de viză pentru Muntenegru?", a: "Nu, cetățenii moldoveni nu au nevoie de viză pentru Muntenegru pentru sejururi de până la 30 de zile." },
        { q: "Cât durează drumul din Chișinău spre Muntenegru?", a: "Cu avionul aproximativ 1h30-2h. Cu mașina sau autocarul aproximativ 12-15 ore." },
        { q: "Care este cel mai bun resort din Muntenegru?", a: "Budva pentru animație și viață de noapte. Kotor pentru romantism și cultură. Ulcinj pentru familii cu copii și plaje lungi." },
        { q: "Muntenegru este scump?", a: "Muntenegru este considerabil mai accesibil față de Grecia sau Croatia. Este una dintre cele mai bune destinații calitate-preț din Adriatică." },
        { q: "Când este sezonul în Muntenegru?", a: "Iunie–septembrie este sezonul principal. Iulie și august sunt cele mai aglomerate. Septembrie este ideal — mai liniștit și prețuri mai bune." },
      ]}
      relatedDestinations={related}
    />
  );
}
